import { i18n } from '@flowus/common/i18n';

export enum DomainStatus {
  INIT = 1,
  CAN_USE = 2,
  CAN_NOT_USE = 3,
  LEN_NOT_RIGHT = 4,
  CHECKING = 5,
}

export const domainErrorMsg = {
  [DomainStatus.INIT]: '',
  [DomainStatus.CAN_USE]: '',
  [DomainStatus.CAN_NOT_USE]: i18n.t('components.space_setting.domain.unavailable'),
  [DomainStatus.LEN_NOT_RIGHT]: i18n.t('components.space_setting.domain.length_error'),
  [DomainStatus.CHECKING]: '',
};
